import { useMemo } from 'react'
import { FontProps } from './type.ts'

export const useFontName = ({ fontSize, fontType }: FontProps) => {
  return useMemo(() => `${fontType}${fontSize ? `-${fontSize}` : ''}`, [fontSize, fontType])
}
